/**
 * Curated REAL student testimonials — verbatim from prod (status='published',
 * consented). Frozen/static and hand-picked for a language mix (English,
 * Amharic, Afaan Oromo) and for the themes students repeat most: it's free,
 * "wish I knew sooner", and it's great for revision.
 *
 * These are real students' words — do not edit the quotes beyond trimming
 * whitespace. The full live feed lives at /testimonials.
 */

export interface StaticTestimonial {
  name: string;
  detail?: string;
  quote: string;
  lang: 'en' | 'am' | 'om';
}

export const LOMI_TESTIMONIALS: StaticTestimonial[] = [
  {
    name: 'Tihitina',
    detail: 'Grade 12',
    quote:
      'Lomi is special fr — especially for revision, cuz it has short ESSLCE tips and notes with entrance-based quiz and past exams.',
    lang: 'en',
  },
  {
    name: 'yeab',
    detail: 'Grade 12',
    quote:
      'ሎሚን በመጠቀሜ በጣም ብዙ ነገሮችን አውቅያለሁ፤ በትንሽ ቀን ሁሉንም በሚባል መልኩ ተረድቻለሁ። ለ Lomi መስራች ትልቅ ክብር አለኝ — እኔን በብዙ ነው የረዳኝ ❤️',
    lang: 'am',
  },
  {
    name: 'Umer',
    detail: 'Grade 12 · Kumbe',
    quote:
      "Lomi baay'ee bareeda. Qormaataaf nu qophessaara, galata guddaa qabnaaf. Lomi kan nuuf qophessitan baay'ee galatoomaa — isin jaallanna nuti barattonni.",
    lang: 'om',
  },
  {
    name: 'Abdulmejid',
    detail: 'Grade 12 · Jigjiga',
    quote:
      'LOMI, you lifted a lot of worries and tension off me. Thank you very much — a lot of people need LOMI but they just don’t know it yet.',
    lang: 'en',
  },
  {
    name: 'Samuel',
    detail: 'Grade 12 · Catholic Kesate Birhan',
    quote:
      'ይህን platform telegram ላይ ነው ሊንኩን ያገኘሁት። እንደዚህ አይነት app ስፈልግ ነበር። በነጻ እንድንጠቀምበት ስለፈቀዳችሁልን እናመሰግናለን።',
    lang: 'am',
  },
  {
    name: 'Miracle',
    detail: 'Grade 12 · Don Bosco',
    quote: 'If you had made this app last year, I would have gotten the highest score 😭',
    lang: 'en',
  },
  {
    name: 'Blen',
    detail: 'Grade 12 · Rofam',
    quote: 'It is such an amazing website — I wish I had known about it before.',
    lang: 'en',
  },
  {
    name: 'Addisalem',
    detail: 'Grade 12',
    quote:
      'ተከፍሎበት ቢሆን እራሱ ያዋጣል። በጣም እናመሰግናለን! በነፃ እንድንጠቀምበት ስለፈቀዳችሁ — ሌላው ፕላትፎርም ኖት አሳጥሮ ብር በሚጠይቅበት ሰአት፣ እናንተ ይሄንን አድርጋችሁ።',
    lang: 'am',
  },
  {
    name: 'kifleyohannes',
    detail: 'Grade 12 · Magic Carpet School',
    quote: 'If I passed matric — damn, you did a good job 👏',
    lang: 'en',
  },
];
